// One order line as the orders lists receive it from the backend.
type OrderProductLine = {
  productTitle?: string;
  sku?: string | null;
  supplier_sku?: string | null;
  quantity: number | string;
  unitPrice: number | string;
  finalPrice: number | string;
};

const formatProductLabel = (product: OrderProductLine) => {
  const codes = [product.sku, product.supplier_sku].filter(Boolean).join(" / ");
  return codes ? `${product.productTitle} (${codes})` : product.productTitle;
};

/**
 * The "Products" cell of the orders lists: one line per product,
 * "Title (SKU / supplier SKU) [quantity X €unit = €total]".
 * Rendered as React text, never as an HTML string — product names and codes
 * are typed by users (or synced from Finvalda) and must not inject markup.
 */
export function OrderProductLines({
  products,
}: {
  products: OrderProductLine[];
}) {
  return (
    // The width floor keeps the column readable when the table is squeezed (a narrow window, a
    // side column next to it): without it the names wrap into a very tall row. The table's own
    // box then scrolls sideways instead.
    <div className="min-w-[220px]">
      {products.map((product, index) => (
        <div key={index}>
          {`${formatProductLabel(product)} [${product.quantity} X €${
            product.unitPrice
          } = €${product.finalPrice}]`}
        </div>
      ))}
    </div>
  );
}
